export default __webpack_public_path__ + "static/media/codingCard.5111842b.png";